import React from 'react';
import {
  SelectedServicesSection,
  SelectedServicesTitle,
  SelectedServiceItem,
  SelectedServiceName,
  SelectedServicePrice,
  DottedPriceServiceItem,
} from '../styles/modalStyles';
import { formatPrice } from '../../../../../utils/formatPrice';

export const SelectedServicesList = ({ selectedServices, services }) => {
  if (selectedServices.length === 0) return null;

  return (
    <SelectedServicesSection>
      <SelectedServicesTitle>Serviço selecionado</SelectedServicesTitle>
      {selectedServices.map(serviceKey => {
        const service = services.find(s => s.key === serviceKey);
        return (
          <SelectedServiceItem key={serviceKey}>
            <SelectedServiceName>{service.title}</SelectedServiceName>
            <DottedPriceServiceItem />
            <SelectedServicePrice>
              {service.valueText ? `${service.valueText} ` : ''}R${formatPrice(service.value)}
            </SelectedServicePrice>
          </SelectedServiceItem>
        );
      })}
    </SelectedServicesSection>
  );
};
